/* @flow */

import React from 'react';
import { Dropdown } from 'semantic-ui-react';

type Value = string | Array<string>;

type Props = {
  name?: string,
  value?: Value,
  label: string,
  placeholder?: string,
  items: Array<Object>,
  loading?: boolean,
  multiple?: boolean,
  onChange: (items: Array<string>) => void,
};

const DEFAULT_ITEM = {
  value: 'none',
  text: 'Tous',
};

const Choices = ({
  items,
  value,
  name,
  onChange,
  placeholder,
  label,
  loading,
  multiple,
}: Props) => {
  const selectionChanged = (_, { value }) => onChange(value);

  const withDefaultItem = multiple ? items : [DEFAULT_ITEM, ...items];

  return (
    <div className="ui field">
      <label>{label}</label>
      <Dropdown
        value={value}
        fluid
        selection
        search
        loading={loading}
        name={name}
        placeholder={placeholder}
        noResultsMessage="Aucun tag correspondant"
        multiple={multiple}
        options={withDefaultItem}
        onChange={selectionChanged}
      />
    </div>
  );
};

export default Choices;



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/Choices.js